/* eslint-disable */
import axios from 'axios';
import toast from './toast'
import store from '../store/store';
import router from '../route';

// Interceptor
axios.interceptors.response.use((response) => {
  // debugger
  return response;
}, function(error) {
  let errorcode = error.response.data;
  console.log(errorcode)
  //  debugger;
  if (errorcode != undefined) {
    if (error.response.status == 400 || error.statusText == 'Bad Request') {
      if (error.response.data.code == 1000) {
        if (error.response.data.data.email) {
          toast.error(error.response.data.data.email[0], 'Email');
        } else if (error.response.data.data.password) {
          toast.error(error.response.data.data.password.msg, 'Password');
        } else {
          toast.error(error.response.data.msg || 'something goes wrong, Try again later')
        }
      } else if (error.response.data.non_field_errors) {
        toast.error(error.response.data.non_field_errors);
      }

    }
    if (error.response.status == 401 || error.statusText == 'Unauthorized') {
      toast.error('Your session expired, please login again');
      store.dispatch('logout');
      router.push('login');
    }
    if (error.response.status == 403 || error.statusText == 'Forbidden') {
      toast.error('Sorry, You are not authorized for it');
      store.dispatch('logout');
      router.push('login');
    }
    if (error.response.status == 415) {
      toast.error('Media not supported');
    }
    return Promise.reject(error.response);
  } else {

  }
});